<script setup>
import { ref } from "vue";
import SlideBtn from "./SlideBtn.vue";

const props = defineProps({
    datas: {
        type: Array,
        required: true,
    },
});
const idx = ref(0);
</script>

<template>
    <div class="mv__ph" :data-mv="idx">
        <div class="mv__ph__bg">
            <picture>
                <source media="(max-width:835px)" :srcset="'/wp/wp-content/themes/apocalypsehotel/assets/img/top/mv/mv_sp_bg_' + datas[idx] + '.webp'" />
                <img :src="'/wp/wp-content/themes/apocalypsehotel/assets/img/top/mv/mv_pc_bg_' + datas[idx] + '.webp'" alt="" />
            </picture>
        </div>
        <Transition name="top">
            <div class="mv__ph__top" :key="idx" :data-mv="idx">
                <picture>
                    <source media="(max-width:835px)" :srcset="'/wp/wp-content/themes/apocalypsehotel/assets/img/top/mv/mv_sp_top_' + datas[idx] + '.webp'" />
                    <img :src="'/wp/wp-content/themes/apocalypsehotel/assets/img/top/mv/mv_pc_top_' + datas[idx] + '.webp'" alt="" />
                </picture>
            </div>
        </Transition>
    </div>
    <div class="mv-arrows">
        <SlideBtn v-model="idx" :length="datas.length"></SlideBtn>
    </div>
</template>
